<template>
<div class="wrap">
<el-row>
    <el-col :span="6">
      <div class="grid-content bg-purple">
          <ul class="numInfo">
              <li>
                  <p>1328</p>
                  <p>活动参与总量</p>
              </li>
              <li>
                  <p>520</p>
                  <p>积累中奖金额</p>
              </li>
              <li>
                  <p>4341</p>
                  <p>扫码总量</p>
              </li>
          </ul>
      </div>
    </el-col>
  <el-col :span="18">
      <div class="grid-content bg-purple-light">
        <div id="main">
        </div>
      </div>
  </el-col>
</el-row>
<p class="realTitle">实时数据</p>
<div class="realTime">
    <ul :class="{ marquee_top : animate }">
        <li v-for="(item,index) in dataArr" :key="'index'+index">
            <img src="../../assets/img/1.png" alt="">
            <div>
            <span>{{item.text}}</span>
            <span style="color:red">{{item.money}}元</span>
            </div>
        </li>
    </ul>
</div>
</div>
</template>
<script>
var ltopdata = [{
			name: '北京',
			value: 2
		},
		{
			name: '天津',
			value: 1
		},
		{
			name: '上海',
			value: 2
		},
		{
			name: '重庆',
			value: 1
		},
		{
			name: '河北',
			value: 1
		},
		{
			name: '河南',
			value: 1
		},
		{
			name: '云南',
			value: 1
		},
		{
			name: '辽宁',
			value: 1
		},
		{
			name: '黑龙江',
			value: 1
		},
		{
			name: '湖南',
			value: 1
		},
	]
import echarts from 'echarts'
export default {
components:{

},
data(){
return {
    dataArr:[
        {
            text:'【43800138001】， 扫码【1007619608722309】参与活动【ID：232，Roy-导购核销】，中得【红包(企业红包0.30元);礼品(国庆大礼包);积分(5);】',
            money:'0.1'
        },
        {
            text:'【43800138001】， 扫码【1007619608722309】参与活动【ID：232，Roy-导购核销】，中得【红包(企业红包0.30元);礼品(国庆大礼包);积分(5);】',
            money:'0.2'
        },
        {
            text:'【43800138001】， 扫码【1007619608722309】参与活动【ID：232，Roy-导购核销】，中得【红包(企业红包0.30元);礼品(国庆大礼包);积分(5);】',
            money:'0.3'
        },
        {
            text:'【43800138001】， 扫码【1007619608722309】参与活动【ID：232，Roy-导购核销】，中得【红包(企业红包0.30元);礼品(国庆大礼包);积分(5);】',
            money:'0.4'
        },
        {
            text:'【43800138001】， 扫码【1007619608722309】参与活动【ID：232，Roy-导购核销】，中得【红包(企业红包0.30元);礼品(国庆大礼包);积分(5);】',
            money:'0.6'
        },
        {
            text:'【43800138001】， 扫码【1007619608722309】参与活动【ID：232，Roy-导购核销】，中得【红包(企业红包0.30元);礼品(国庆大礼包);积分(5);】',
            money:'0.7'
        },
        {
            text:'【43800138001】， 扫码【1007619608722309】参与活动【ID：232，Roy-导购核销】，中得【红包(企业红包0.30元);礼品(国庆大礼包);积分(5);】',
            money:'0.8'
        }
    ],
    charts: '',
    animate:false,
    option: {
       tooltip: {
                show: true,
                formatter(params) {
                    var percent = 0;
                    var total = 0;
                    for (var i = 0; i < ltopdata.length; i++) {
                        if (params.name == ltopdata[i].name) {
                            if (params.name !== '') {
                                return params.name + '\n' + ltopdata[i].value;
                            } else {
                                return '';
                            }
                        }
                    }
                },
            },
            visualMap: {
                min: 0,
                max: 100,
                text: ['', ''],
                realtime: false,
                calculable: true,
                inRange: {
                    color: ['#f1f1f1', '#25aed4']
                },
                orient: 'horizontal',
                bottom: '-3%',
                left: 'center',
                itemWidth: '12px',
                itemHeight: '200px',
            },
            geo: {
                map: 'china',
                zoom: 1.2,
                label: {
                normal: {
                    show: true,
                    color: '#333',
                },
                emphasis: {
                    show: true,
                },
                },
                itemStyle: {
                    normal: {
                        areaColor: '#f1f1f1',
                        borderColor: '#fff',
                    },
                    emphasis: {
                        areaColor: '#5CD2B7'
                    }
                }
            },
            series: [{
                type: 'map',
                mapType: 'china',
                geoIndex: 0,
                label: {
                    normal: {
                        show: true
                    },
                    emphasis: {
                        show: true
                    }
                },
                data:[{
                    name: '北京',
                    value: 2
                },]
                // province
            }]
        },
    }
},
methods:{
    drawLine(id){
        this.charts = echarts.init(document.getElementById(id))
        this.charts.setOption(this.option)
    },
    showMarquee() {
　　　　　　this.animate = true;
           setTimeout(()=>{
　　　　　　　　this.dataArr.push(this.dataArr[0]);
　　　　　　　　this.dataArr.shift();
　　　　　　　　this.animate = false;
　　　　　　},500)
　　}, 
},
created(){
    setInterval(this.showMarquee, 2000)
},
mounted() {
    this.$nextTick(function() {
        this.drawLine('main');
    })
},
}
</script>
<style lang="scss" scoped>
.wrap{
    background-color: #fff;
    color: #666;
    // padding-bottom: 15px;
    .marquee_top {
    transition: all 1s;
    margin-top: -100px;
    }
    .numInfo{
       margin: 70px 65px;
       li{
           margin-bottom: 45px;
           p:nth-child(1){
                color: #f0ad4e;
                font-size: 32px;
                // margin-bottom: 10px;
           }
           p:nth-child(2){
                font-size: 16px;
           }
       } 
    }
    #main{
        width: 100%;
        height: 450px;
    }
    .realTitle{
        padding: 20px;
        border-bottom: 1px solid #e3e3e3;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 600;
        width: 93%;
        margin: 9px auto;
    }
    .realTime{
        // padding: 40px 30px;
        height: 328px;
        overflow: hidden;
        width: 96%;
        margin: 0 auto;
        // padding-bottom: 
        ul{
            height: 328px;
            overflow: hidden;
            li{
                margin-bottom: 15px;
                div{
                position: relative;top: -38px;left: 55px;
                }
                img{
                width: 50px;
                height: 50px;
                border-radius: 100%; 
                }
            }
        }
    }
}

</style>